import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-on-boarding-video',
  templateUrl: './on-boarding-video.component.html',
  styleUrls: ['./on-boarding-video.component.scss']
})
export class OnBoardingVideoComponent implements OnInit {
  show = false;
  @Input() videoUrl = '';
  constructor() { }

  ngOnInit() {
  }
}
